export const integrations = [
  {
    key: 'integration-web',
    title: 'Interface web prête à l’emploi',
    text: 'Une interface de chat IA complète, accessible depuis le navigateur, sur poste et mobile.',
    iconFamily: 'fa-solid',
    icon: 'window-maximize',
  },
  {
    key: 'integration-modeles',
    title: 'Catalogue de modèles',
    text: 'Plusieurs modèles disponibles selon vos besoins : rédaction, code, analyse, synthèse.',
    iconFamily: 'fa-solid',
    icon: 'layer-group',
  },
  {
    key: 'integration-disponibilite',
    title: 'Haute disponibilité',
    text: 'Architecture robuste avec RPO = 6h et RTO = 1h pour limiter l’impact d’un incident.',
    iconFamily: 'fa-solid',
    icon: 'network-wired',
  },
  {
    key: 'integration-backups',
    title: 'Sauvegardes',
    text: 'Paramétrables selon vos besoins, avec conservation par défaut de 24h à 7 jours.',
    iconFamily: 'fa-solid',
    icon: 'floppy-disk',
  },
]
